import React, { useEffect, useState } from 'react';
import { TextField, MenuItem, Menu } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';

const filterOptions = [
  {
    id: 'day-pass',
    label: 'Day Pass',
    label_es: 'Pase por un día',
    spaceType: 'coworking',
  },
  {
    id: 'small',
    label: 'Small Room',
    label_es: 'Sala pequeña',
    spaceType: 'sala de juntas',
  },
  {
    id: 'medium',
    label: 'Medium Room',
    label_es: 'Sala mediana',
    spaceType: 'sala de juntas',
  },
  {
    id: 'large',
    label: 'Large Room',
    label_es: 'Sala grande',
    spaceType: 'sala de juntas',
  },
];

const ParadiseNavbarContent = ({
  lenguageData,
  values,
  setFieldValue,
  staticLocationsFromSearch,
  setSelectedSuggestionxCBO,
  isMobile,
  isSearchPage,
}) => {
  const navigate = useNavigate();
  const userData = useSelector(state => state.user);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  const userDisplayName = userData
    ? [userData.name, userData.lastName].filter(Boolean).join(' ').trim() ||
      userData.email ||
      ''
    : '';

  const handleLogin = () => {
    if (lenguageData === 'ES') {
      navigate('/iniciar-sesion');
    } else {
      navigate('/login');
    }
  };

  const closeSession = () => {
    setUserMenuAnchor(null);
    localStorage.removeItem('user');
    localStorage.removeItem('auth_data');
    localStorage.removeItem('access_token');
    window.location.href = '/';
  };

  useEffect(() => {
    if (!values.location && staticLocationsFromSearch?.length > 0) {
      const defaultLocation = staticLocationsFromSearch[0];

      setFieldValue('location', defaultLocation.description);
      setSelectedSuggestionxCBO?.(defaultLocation);
    }

    if (!values.filter) {
      const defaultFilter = filterOptions[0];

      setFieldValue('filter', defaultFilter.id);

      dispatch(
        setSearchFormData({
          ...currentSearchFormData,
          spaceType: defaultFilter.spaceType,
          filter: defaultFilter.id,
        }),
      );
    }
  }, []);

  const handleRegister = () => {
    if (lenguageData === 'ES') {
      navigate('/registrarse');
    } else {
      navigate('/signup');
    }
  };

  const handleDate = () => {
    if (lenguageData === 'ES') {
      navigate('/reservacion-fecha');
    } else {
      navigate('/reservation-date');
    }
  };

  const dispatch = useDispatch();
  const currentSearchFormData = useSelector(state => state.searchFormData);

  const handleFilterChange = optionId => {
    const selected = filterOptions.find(o => o.id === optionId);
    if (!selected) return;

    // Formik / estado local
    setFieldValue('filter', optionId);

    // Redux
    dispatch(
      setSearchFormData({
        ...currentSearchFormData,
        spaceType: selected.spaceType,
        filter: optionId,
      }),
    );
    if (!isMobile && !isSearchPage) {
      navigate('/search');
    }
  };
  return (
    <FlexContainer
      className="width100 justify-between align-center"
      style={{
        padding: '20px 20px',
        gap: '12px',
        zIndex: 1000,
      }}
    >
      <TextField
        select
        fullWidth
        label={lenguageData === 'ES' ? 'Dónde' : 'Where'}
        value={values.location} 
        onChange={e => {
          const value = e.target.value;

          setFieldValue('location', value);

          const selected = staticLocationsFromSearch?.find(
            s => s.description === value,
          );

          if (selected) setSelectedSuggestionxCBO?.(selected);

          if (!isMobile && !isSearchPage) {
            navigate('/search');
          }
        }}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
          sx: {
            color: '#fff',
            fontWeight: 600,
            transform: 'translate(16px, 4px) scale(0.85)',
            '&.Mui-focused': { color: '#fff' },
          },
        }}
        InputProps={{
          notched: false,
          sx: {
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            borderRadius: '14px',
            paddingTop: '10px',
            height: '46px',
            display: 'flex',
            alignItems: 'center',

            '& .MuiSelect-select': {
              padding: '8px 16px 0px 16px !important',
              display: 'flex',
              alignItems: 'center',
              minHeight: 'auto !important',
            },

            '& .MuiSelect-icon': {
              top: 'calc(25% + 6px)',
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #fff',
            },
          },
        }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: '#566dab',
                color: '#fff',
                marginTop: '8px',
                '& .MuiMenuItem-root': {
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                  },
                },
              },
            },
          },
        }}
      >
        {staticLocationsFromSearch?.map(s => (
          <MenuItem key={s.place_id} value={s.description}>
            {s.description}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        fullWidth
        type="text"
        placeholder="Today"
        onClick={handleDate}
        label={lenguageData === 'ES' ? 'Cuándo' : 'When'}
        value={values.startDate}
        onChange={e => setFieldValue('startDate', e.target.value)}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
          sx: {
            color: '#fff',
            fontWeight: 600,
            transform: 'translate(16px, 4px) scale(0.85)',
            '&.Mui-focused': {
              color: '#fff',
            },
          },
        }}
        InputProps={{
          notched: false,
          sx: {
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            borderRadius: '14px',
            paddingTop: '12px',
            paddingBottom: '3px',

            '& input': {
              padding: '8px 16px 0px 16px',
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },

            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },

            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #fff',
            },

            '& input[type="date"]::-webkit-calendar-picker-indicator': {
              cursor: 'pointer',
              filter: 'invert(1)',
            },
          },
        }}
      />
      <TextField
        select
        fullWidth
        label={lenguageData === 'ES' ? 'Filtro' : 'Filter'}
        value={values.filter || ''}
        onChange={e => handleFilterChange(e.target.value)}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
          sx: {
            color: '#fff',
            fontWeight: 600,
            transform: 'translate(16px, 4px) scale(0.85)',
            '&.Mui-focused': { color: '#fff' },
          },
        }}
        InputProps={{
          notched: false,
          sx: {
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            borderRadius: '14px',
            paddingTop: '10px',
            height: '46px',
            display: 'flex',
            alignItems: 'center',

            '& .MuiSelect-select': {
              padding: '8px 16px 0px 16px !important',
              display: 'flex',
              alignItems: 'center',
              minHeight: 'auto !important',
            },

            '& .MuiSelect-icon': {
              top: 'calc(25% + 6px)',
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },

            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid #fff',
            },

            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #fff',
            },
          },
        }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: '#566dab',
                color: '#fff',
                marginTop: '8px',
                '& .MuiMenuItem-root': {
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                  },
                },
              },
            },
          },
        }}
      >
        {filterOptions.map(opt => (
          <MenuItem key={opt.id} value={opt.id}>
            {lenguageData === 'ES' ? opt.label_es : opt.label}
          </MenuItem>
        ))}
      </TextField>
      {/* Sign Up / Sign In o nombre de usuario (misma lógica que NewHeaderModal: state.user) */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginLeft: '50px',
        }}
      >
        {userData ? (
          <>
            <button
              type="button"
              aria-haspopup="true"
              aria-expanded={Boolean(userMenuAnchor)}
              onClick={e => setUserMenuAnchor(e.currentTarget)}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                fontWeight: 600,
                padding: '8px 6px',
                borderRadius: '12px',
                border: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                maxWidth: '260px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                title={userDisplayName}
              >
                {userDisplayName}
              </span>
              <i
                className="fa fa-chevron-down"
                style={{ fontSize: '11px', opacity: 0.9, flexShrink: 0 }}
                aria-hidden
              />
            </button>
            <Menu
              anchorEl={userMenuAnchor}
              open={Boolean(userMenuAnchor)}
              onClose={() => setUserMenuAnchor(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              disableScrollLock
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  background: 'linear-gradient(90deg, #f985c4, #566dab 50%)',
                  color: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.22)',
                  overflow: 'hidden',
                  '& .MuiMenuItem-root': {
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '0.95rem',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.14)',
                    },
                  },
                },
              }}
              MenuListProps={{ dense: true }}
            >
              <MenuItem onClick={closeSession}>
                {lenguageData === 'ES' ? 'Cerrar sesión' : 'Log Out'}
              </MenuItem>
            </Menu>
          </>
        ) : (
          <>
            <button
              onClick={handleRegister}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                fontWeight: '600',
                padding: '8px 2px',
                borderRadius: '12px',
                border: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              {lenguageData === 'ES' ? 'Registrarse' : 'Sign Up'}
            </button>

            <span style={{ color: 'white', opacity: 0.6 }}>/</span>

            <button
              onClick={handleLogin}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                fontWeight: '600',
                borderRadius: '12px',
                border: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              {lenguageData === 'ES' ? 'Iniciar sesión' : 'Sign In'}
            </button>
          </>
        )}
      </div>
    </FlexContainer>
  );
};

export default ParadiseNavbarContent;
